export function sortPlansByFee(plans, planDisplayOrder = null) {
  return plans.slice().sort((a, b) => {
    if (planDisplayOrder) {
      const leftOrder = planDisplayOrder[a["ID"]];
      const rightOrder = planDisplayOrder[b["ID"]];

      if (leftOrder !== undefined || rightOrder !== undefined) {
        return (
          (leftOrder ?? Number.MAX_SAFE_INTEGER) -
            (rightOrder ?? Number.MAX_SAFE_INTEGER) ||
          Number(a["Fee"]) - Number(b["Fee"]) ||
          String(a["Title"]).localeCompare(String(b["Title"]))
        );
      }
    }

    return (
      Number(a["Fee"]) - Number(b["Fee"]) ||
      String(a["Title"]).localeCompare(String(b["Title"]))
    );
  });
}
